import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { RootLayout } from './layouts/layouts'

// Pages
import { WorkbenchPage } from './pages/workbench-page'
import { PublicGifPage } from './pages/public-gif-page'

interface WorkbenchRedirectProps {
  view?: 'studio' | 'gif' | 'library'
  library?: 'videos' | 'frames' | 'gifs'
}

function WorkbenchRedirect({ view, library }: WorkbenchRedirectProps) {
  const location = useLocation()
  const params = new URLSearchParams(location.search)

  if (view) params.set('view', view)
  if (library) params.set('library', library)

  const search = params.toString()
  return <Navigate to={{ pathname: '/', search: search ? `?${search}` : '' }} replace />
}

function App() {
  return (
    <Routes>
          {/* Public routes */}
          <Route path="/" element={<RootLayout />}>
            <Route index element={<WorkbenchPage />} />
            
            {/* Studio - main workspace (open to guests, F2) */}
            <Route path="studio" element={<WorkbenchRedirect view="studio" />} />
            
            {/* Legacy redirect from /extractor to /studio */}
            <Route path="extractor" element={<WorkbenchRedirect view="studio" />} />
            
            {/* Unified Library with tabs */}
            <Route path="library" element={<WorkbenchRedirect view="library" library="videos" />} />
            <Route path="library/videos" element={<WorkbenchRedirect view="library" library="videos" />} />
            <Route path="library/frames" element={<WorkbenchRedirect view="library" library="frames" />} />
            <Route path="library/gifs" element={<WorkbenchRedirect view="library" library="gifs" />} />
            
            {/* GIF Creator (open to guests, F2) */}
            <Route path="gif-creator" element={<WorkbenchRedirect view="gif" />} />
            
            {/* Legacy redirects */}
            <Route path="frames" element={<WorkbenchRedirect view="library" library="frames" />} />

            {/* F3, Public shared GIF view */}
            <Route path="g/:shortId" element={<PublicGifPage />} />

            {/* Legacy tool URLs now open the relevant workspace view. */}
            <Route path="tools/video-to-gif" element={<WorkbenchRedirect view="gif" />} />
            <Route path="tools/extract-frames" element={<WorkbenchRedirect view="studio" />} />
            <Route path="tools/gif-maker" element={<WorkbenchRedirect view="gif" />} />
            <Route path="tools/video-to-png" element={<WorkbenchRedirect view="studio" />} />
          </Route>
          
          {/* Catch all - redirect to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default App

